import {customElement, state} from "lit/decorators.js";
import {UnLitElement} from "../../../common/elements";
import {html, type TemplateResult} from "lit";
import {WarningLevel} from "../validations/validations";
import type {Nullable} from "../../../bootstrap/common/types";
import type {ValidationFailure} from "./formInputElement";
import {classMap} from "lit/directives/class-map.js";

@customElement("eop-form-validation-messages")
export class EopFormValidationMessages extends UnLitElement {

    @state()
    protected validationFailures: ValidationFailure[];

    @state()
    protected isInErrorState: boolean;

    @state()
    protected  isInWarningState: boolean;

    public render(): TemplateResult {
        const texts = this.isInErrorState || this.isInWarningState
            ? this.renderValidationTexts()
            : null;

        return html`
            <div class="validation-messages">
                ${this.renderValidationIcon()}
                <div class="error-messages">${texts}</div>
            </div>
        `;
    }

    private renderValidationTexts(): TemplateResult {
        return html`
            ${(this.renderErrors())}
            ${(this.renderWarnings())}
        `;
    }

    private renderErrors(): TemplateResult[] {
        return this.validationFailures
            .filter(message => message.warningLevel === WarningLevel.ERROR)
            .map(failure => this.errorMessage(failure.message));
    }

    private renderWarnings(): TemplateResult[] {
        return this.validationFailures
            .filter(message => message.warningLevel === WarningLevel.WARNING)
            .map(failure => this.warningMessage(failure.message));
    }

    protected renderValidationIcon(): Nullable<TemplateResult> {
        const icon = this.renderIcon();
        if (!icon) {
            return null;
        }

        const colorMap = classMap({
            "error": this.isInErrorState,
            "warning": this.isInWarningState
        });

        return html`
            <div class="validation-icon ${colorMap}">${icon}</div>`;
    }
    protected errorMessage(message: string): TemplateResult {
        return html`
            <div class="error-message">${message}</div>`;
    }

    private renderIcon(): Nullable<TemplateResult> {
        if (this.isInErrorState) {
            return html`<eop-svg-sprite-icon icon-id="error"></eop-svg-sprite-icon>`;
        }
        if (this.isInWarningState) {
            return html`<eop-svg-sprite-icon icon-id="warn"></eop-svg-sprite-icon>`;
        }
        return null;
    }

    private warningMessage(message: string): TemplateResult {
        return html`
            <div class="warning-message">${message}</div>`;
    }
}
